// Front-end for the Stories page (Pages/Stories/Index.cshtml). Two jobs:
//   1. The Airbnb-style pill segmented control + business-section filter. Nothing is
//      selected by default (the "All" state — every section shown); clicking a pill
//      selects it (3D surface + icon pop via the .active CSS) and shows only that
//      category's platforms; clicking the active pill clears it back to All.
//   2. The per-card favorite heart — toggles a saved state, persisted in localStorage
//      (keyed fav:<id>) so it survives reloads.
// Peer Vite entry — never imports the SCSS.

// ── Category pills ───────────────────────────────────────────────────────────
// Which gig platforms (by data-business slug) each category shows.
const CATEGORY_BUSINESSES: Record<string, string[]> = {
    ride: ['uber', 'lyft'],
    delivery: ['uber', 'doordash', 'amazonflex', 'grubhub', 'skipcourier', 'goshare'],
    shop: ['instacart', 'uber', 'doordash'],
};

const tabs = Array.from(document.querySelectorAll<HTMLButtonElement>('.category-tabs .category-tab'));
const businesses = Array.from(document.querySelectorAll<HTMLElement>('.business'));

// Show only the sections whose data-business is in the active category; null (All)
// shows every section.
function filterBusinesses(category: string | null): void {
    const allowed = category ? CATEGORY_BUSINESSES[category] : null;
    businesses.forEach((section) => {
        section.hidden = allowed ? !allowed.includes(section.dataset.business ?? '') : false;
    });
}

function selectTab(tab: HTMLButtonElement): void {
    const deselect = tab.classList.contains('active'); // click the active pill → back to All
    tabs.forEach((t) => {
        const on = !deselect && t === tab;
        t.classList.toggle('active', on);
        t.setAttribute('aria-pressed', String(on));
    });
    filterBusinesses(deselect ? null : (tab.dataset.cat ?? null));
}

tabs.forEach((tab) => tab.addEventListener('click', () => selectTab(tab)));

// ── Favorite hearts ──────────────────────────────────────────────────────────
// Keys are positional (card-<n>) — fine for the hard-coded demo cards; swap for a real
// story id once the content is dynamic.
const hearts = Array.from(document.querySelectorAll<HTMLButtonElement>('.business-card-fav'));

hearts.forEach((heart, index) => {
    const key = `fav:card-${index}`;

    const paint = (saved: boolean): void => {
        heart.classList.toggle('is-fav', saved);
        heart.setAttribute('aria-pressed', String(saved));
    };

    // Reflect any previously saved state on load.
    paint(localStorage.getItem(key) !== null);

    heart.addEventListener('click', () => {
        const saved = localStorage.getItem(key) !== null;
        if (saved) localStorage.removeItem(key);
        else localStorage.setItem(key, '1');
        paint(!saved);
    });
});
